import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import InterpreterModeOutlinedIcon from '@mui/icons-material/InterpreterModeOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import { ReactComponent as Bookicon } from '../../../Assets/Bookicon.svg';
import { ReactComponent as InfoHub } from '../../../Assets/icons/InfoHub.svg';
import { ReactComponent as Events } from '../../../Assets/icons/EventsBlue.svg';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  name?: string;
  handleClose?: any;
}

const MobileNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, name, handleClose }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => {
    return items && items !== '';
  });

  const isInInfoHubSection = ['photos', 'resources', 'business%20directory'].includes(getFirstPath[0]);
  const [openInfoHub, setOpenInfoHub] = useState(isInInfoHubSection);

  const navigationItems = [
    {
      icon: <HomeOutlinedIcon />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: <AccountCircleIcon />,
      label: 'My Profile',
      link: routes.myProfile,
      name: 'myProfile',
    },
    {
      icon: <AutoAwesomeIcon />,
      label: 'Feed',
      link: routes.myFeed,
      name: 'my%20Feed',
    },
    {
      icon: <Events style={{ stroke: '#5981FF' }} />,
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: <WorkOutlineOutlinedIcon />,
      label: 'Jobs',
      link: routes.jobs,
      name: 'jobs',
    },
    {
      icon: <WorkOutlineOutlinedIcon />,
      label: 'Placements',
      link: routes.placements,
      name: 'placements',
    },

    {
      icon: <InterpreterModeOutlinedIcon />,
      label: 'Mentorship',
      link: routes.mentorship,
      name: 'mentorship',
    },
    {
      icon: <PaymentsOutlinedIcon />,
      label: 'Fundraise',
      link: routes.fundraise,
      name: 'fundraise',
    },
    {
      icon: <PeopleOutlineOutlinedIcon />,
      label: 'Network',
      link: routes.network,
      name: 'network',
    },
    {
      icon: <GroupsOutlinedIcon />,
      label: 'Groups',
      link: routes.groups,
      name: 'groups',
    },
    {
      icon: <InfoHub style={{ stroke: '#5981FF' }} />,
      label: 'Info Hub',
      name: 'infohub',
      isDropdown: true,
      children: [
        {
          label: 'Photos',
          link: routes.photos,
          name: 'photos',
          icon: <PermMediaOutlinedIcon />,
        },
        {
          label: 'Business directory',
          link: routes.businessdirectory,
          name: 'business%20directory',
          icon: <ComputerOutlinedIcon />,
        },
        {
          label: 'Resources',
          link: routes.resources,
          name: 'resources',
          icon: <Bookicon style={{ stroke: '#5981FF' }} />,
        },
      ],
    },
    {
      icon: <DocumentScannerOutlinedIcon />,
      label: 'Survey',
      link: routes.survey,
      name: 'survey',
    },
    {
      icon: <ContactSupportOutlinedIcon />,
      label: 'Service & Support',
      link: routes.service,
      name: 'service',
    },
    {
      icon: <SettingsOutlinedIcon />,
      label: 'Settings',
      link: routes.settings,
      name: 'settings',
    },
    {
      icon: <ModeCommentOutlinedIcon />,
      label: 'Chat',
      link: routes.chats,
      name: 'chats',
    },
  ];

  const handleNavigation = (link: string, index: number) => {
    console.log('Mobile navigation to:', link);

    if (handleClose) {
      handleClose();
    }

    setTimeout(() => {
      handleListClick(link, index);
    }, 50);
  };

  const isInfoHubActive = navigationItems.find((item: any) => item.isDropdown)?.children?.some((subItem: any) => getFirstPath[0] === subItem.name);

  return (
    <>
      <Box sx={{ flex: 1, overflowY: 'auto', height: 'calc(100vh - 230px)' }}>
        {navigationItems.map((item, index) => {
          if (item.isDropdown) {
            return (
              <div key={item.label}>
                <ListItemButton
                  onClick={() => setOpenInfoHub(!openInfoHub)}
                  sx={{
                    py: 1.5,
                    pl: 2,
                    pr: 1,
                    borderRadius: '4px',
                    '&:hover': {
                      backgroundColor: '#f5f8ff',
                    },
                    ...(isInfoHubActive && {
                      backgroundColor: '#f5f8ff',
                    }),
                  }}
                >
                  <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    sx={{
                      m: 0,
                      '& .MuiTypography-root': {
                        fontSize: '16px',
                        fontWeight: isInfoHubActive ? 500 : 400,
                        color: isInfoHubActive ? '#4e6af6' : '#333',
                      },
                    }}
                  />
                  {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                  {item.children.map((subItem: any) => {
                    const isSubItemActive = getFirstPath[0] === subItem.name;
                    return (
                      <ListItemButton
                        key={subItem.label}
                        onClick={() => handleNavigation(subItem.link, index)}
                        sx={{
                          py: 1.5,
                          pl: 4,
                          pr: 1,
                          borderRadius: '4px',
                          '&:hover': {
                            backgroundColor: '#f5f8ff',
                          },
                          ...(isSubItemActive && {
                            backgroundColor: '#f5f8ff',
                          }),
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>{subItem.icon}</ListItemIcon>
                        <ListItemText
                          primary={subItem.label}
                          sx={{
                            m: 0,
                            '& .MuiTypography-root': {
                              fontSize: '16px',
                              fontWeight: isSubItemActive ? 500 : 400,
                              color: isSubItemActive ? '#4e6af6' : '#333',
                            },
                          }}
                        />
                      </ListItemButton>
                    );
                  })}
                </Collapse>
              </div>
            );
          } else {
            return (
              <ListItemButton
                key={index}
                onClick={() => handleNavigation(item.link || '', index)}
                sx={{
                  py: 1.5,
                  pl: 2,
                  pr: 1,
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#f5f8ff',
                  },
                  ...(getFirstPath[0] === item.name && {
                    backgroundColor: '#f5f8ff',
                  }),
                }}
              >
                <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    m: 0,
                    '& .MuiTypography-root': {
                      fontSize: '16px',
                      fontWeight: getFirstPath[0] === item.name ? 500 : 400,
                      color: getFirstPath[0] === item.name ? '#4e6af6' : '#333',
                    },
                  }}
                />
              </ListItemButton>
            );
          }
        })}
      </Box>
      <Box
        sx={{
          borderTop: '1px solid #EAEFFF',
          mt: 2,
          pt: 2,
          px: 1,
          position: 'fixed',
          bottom: 0,
          width: 'calc(100% - 32px)',
          backgroundColor: 'white',
        }}
      >
        <ListItemButton
          onClick={() => handleNavigation(routes.login, navigationItems.length + 1)}
          sx={{
            py: 1.5,
            pl: 2,
            pr: 1,
            borderRadius: '4px',
            '&:hover': {
              backgroundColor: '#f5f8ff',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText
            primary="Logout"
            sx={{
              m: 0,
              '& .MuiTypography-root': {
                fontSize: '16px',
                color: '#333',
              },
            }}
          />
        </ListItemButton>
      </Box>
    </>
  );
};

export default MobileNavTabs;
